import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private flags: Record<string, boolean> = {};

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return lastValueFrom(
      this.http
        .get<Record<string, boolean>>('/assets/feature-flags.json')
        .pipe(tap(flags => (this.flags = flags)))
    ).then(() => {});
  }

  isEnabled(flag: string): boolean {
    return this.flags[flag] ?? false;
  }
}
